import React, { FC } from 'react'
import * as app from '../styles/App.styled'
import * as projects from '../styles/Projects.styled'
import rsalgo from '../assets/rsalgo.png'
import catrs from '../assets/catrs.svg'
import SlideInMotion, {
  SlideInDirection,
} from './SlideInMotion'

export const ProjectsTwo:FC = () => {
  const { left, right } = SlideInDirection

  return (
    <app.StyledSection>

      <app.StyledCardLargeLightBlack>
        <projects.StyledA
          href='https://www.npmjs.com/package/@epic-effx/rsalgo'
          target='_blank'
          rel='noreferrer'
        >
          <SlideInMotion direction={right}>
            <projects.StyledTextWrapper>
              <div>RSAlgo</div>
              <div>fast running algorithms for .js/.ts written in rust</div>
            </projects.StyledTextWrapper>
          </SlideInMotion>
          <SlideInMotion direction={left}>
            <projects.StyledCcrate src={rsalgo}/>
          </SlideInMotion>
        </projects.StyledA>
      </app.StyledCardLargeLightBlack>

      <app.StyledCardSmallDarkBlack>
        <projects.StyledA
          href='https://www.createapplicationtemplaters.com/'
          target='_blank'
          rel='noreferrer'
        >
          <projects.StyledCat src={catrs} alt='catrs'/>
          <projects.StyledTextTitleCat>Create Application Template RS (CATrs)</projects.StyledTextTitleCat>
          <div>provides a Rspack + SWC configured app template</div>
        </projects.StyledA>
      </app.StyledCardSmallDarkBlack>

    </app.StyledSection>
  )
}
